module.exports = __webpack_public_path__ + "img/Unofficial_flag_of_Guadeloupe.08aae228.svg";